import posthog from "posthog-js";

// Super properties set once on identify
let _superProps: Record<string, any> = {};

export function initPostHog() {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (!key) return;
  posthog.init(key, {
    api_host: "https://us.i.posthog.com",
    loaded: (ph) => ph.debug(false),
    capture_pageview: true,
    capture_pageleave: true,
  });
}

function track(event: string, properties?: Record<string, any>) {
  posthog.capture(event, { ..._superProps, ...properties, timestamp: new Date().toISOString() });
}

export function identifyUser(user: { id: string; email: string; plan_type?: string; state?: string | null }) {
  _superProps = { user_plan: user.plan_type || "free_user", user_state: user.state || null };
  posthog.identify(user.id, {
    email: user.email,
    plan_type: user.plan_type || "free_user",
    state: user.state || null,
  });
}

export function resetAnalytics() {
  _superProps = {};
  posthog.reset();
}

export function trackCalculatorOpened(calculator_id: string, category: string, source: "direct" | "hub" | "blog") {
  track("calculator_opened", { calculator_id, category, source });
}

export function trackCalculationCompleted(calculator_id: string, result_amount: number, eligibility?: string) {
  track("calculation_completed", { calculator_id, result_amount, eligibility });
}

export function trackReportViewed(calculator_id: string, plan_type: string, sections_visible: number) {
  track("report_viewed", { calculator_id, plan_type, sections_visible });
}

export function trackUpgradeModalShown(trigger: "limit" | "blur" | "cta", calculator_id?: string) {
  track("upgrade_modal_shown", { trigger, calculator_id });
}

export function trackUpgradeClicked(plan_type: string, source: string) {
  track("upgrade_clicked", { plan_type, source });
}

export function trackPdfDownloaded(calculator_id: string) {
  track("pdf_downloaded", { calculator_id });
}

export function trackSignupCompleted(source: string, occupation?: string) {
  track("signup_completed", { source, occupation });
}
